import { BrandsCard } from './BrandsCard'
import LocalizedLink from '@components/Localization/LocalizedLink'
import { useBrandPreferences } from '@lib/hooks/use-brand-preferences'
import { getKontentImage } from '@lib/kontent'
import { BrandListItem } from '@pages/_brands-page'
import { useTranslation } from 'next-i18next'
import { useRouter } from 'next/router'
import { FC } from 'react'
import { cn } from '@lib/cn'

type BrandsListBrandsRowProps = {
  items: BrandListItem[]
  isOpen?: boolean
}

export const BrandsListBrandsRow: FC<BrandsListBrandsRowProps> = ({ isOpen = true, items }) => {
  const { toggleBrand, preferredBrands } = useBrandPreferences()
  const { asPath } = useRouter()
  const { t } = useTranslation('navigation')
  const shouldAlterTudorLink = asPath === '/house-of-gassan'

  return (
    <div
      className={cn(
        'grid h-0 max-h-0 grid-cols-2 overflow-hidden transition-[max-height] duration-500',
        'sm:grid-cols-3 sm:pt-6',
        'lg:grid lg:h-auto lg:max-h-none lg:grid-cols-4 lg:gap-6 lg:pt-6',
        'xl:grid-cols-6',
        isOpen && 'h-auto max-h-none gap-4 pt-4',
      )}
      style={{
        transitionTimingFunction: 'cubic-bezier(0.23,1,0.32,1)',
      }}
      data-open={isOpen ? '' : undefined}
    >
      {items.map((brand, index) => {
        const imageSource = brand.logo.value[0]
          ? getKontentImage(brand.logo.value[0].url, { width: 270 })
          : null
        let href = `/${brand.url_slug.value}`

        // Exception for Chopard
        if (brand.url_slug.value.toLowerCase().includes('chopard')) {
          href = '/chopard'
        }

        // Special exception for Tudor, link shouldn't be altered everywhere,
        // just here and in the Navigation
        if (href === '/tudor' && shouldAlterTudorLink) {
          href = t('about-tudor')
        }

        return (
          <LocalizedLink href={href} key={index} passHref>
            <a>
              <BrandsCard
                description={brand.logo.name}
                imageSource={imageSource}
                name={brand.title.value}
                brandId={brand.brandId}
                isOnWishlist={preferredBrands.includes(brand.brandId as number)}
                onClickWishlist={() => toggleBrand(brand.brandId as number, brand.title.value)}
              />
            </a>
          </LocalizedLink>
        )
      })}
    </div>
  )
}
